/*
 * artisans.js — cinta (marquee) de emprendedores.
 * Escritorio: el hover ya pausa y revela (CSS).
 * Táctil/móvil: al tocar una tarjeta se pausa la cinta y se revela su historia;
 * al tocar fuera o de nuevo, se reanuda.
 */
if (!customElements.get('artisan-card')) {
  customElements.define(
    'artisan-card',
    class ArtisanCard extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(hover: hover)').matches) return; // solo táctil

        this.addEventListener('click', (e) => {
          if (e.target.closest('a')) return; // dejar navegar enlaces
          e.preventDefault();
          const marquee = this.closest('.artisans__marquee');
          const open = this.classList.contains('is-revealed');

          // Cerrar otras tarjetas
          if (marquee) {
            marquee.querySelectorAll('artisan-card.is-revealed').forEach((c) => {
              if (c !== this) c.classList.remove('is-revealed');
            });
          }
          this.classList.toggle('is-revealed', !open);
          if (marquee) marquee.classList.toggle('is-paused', !open);
        });
      }
    }
  );
}
